// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__26snQ","info":"App_info__3Et8L","expanded":"App_expanded__1ZUu0"};